import { Component, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { CellClickEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'cp-invoice-search-results',
  templateUrl: './invoice-search-results.component.html',
  styleUrls: ['./invoice-search-results.component.scss']
})
export class InvoiceSearchResultsComponent {
  SearchTarget: SearchTarget;
  @Input() searchFilter: string;
  @Input() loading: boolean = false;
  @Input() resultsData: any;
  @Input() searchTarget: SearchTarget = SearchTarget.inventory;

  @Output() cellClickEvent = new EventEmitter<CellClickEvent>();
  @Output() closeSearchResultsEvent = new EventEmitter<null>();

  skip: number = 0;
  cellClick(dataItem: CellClickEvent) {
    this.cellClickEvent.emit(dataItem);
  }
  onCloseSearchResults() {
    this.closeSearchResultsEvent.emit(null);
  }
}
